export default {
    ca: {
        highlightOne: {
            title: 'Explora',
            subtitle: 'la geoinformació de Catalunya i el món',
            columnOne: {
                title: 'Mapes i imatges aèries',
                content: 'Bases topogràfiques, ortofotomapes vigents, límits administratius, mapes històrics i altres.<br/>Accedeix a tota la informació de l\'<a  target="_blank" href="http://www.icgc.cat">Institut Cartogràfic i Geològic de Catalunya (ICGC)</a>',
            },
            columnTwo: {
                title: 'Dades en temps real',
                content: 'Estat i incidències de trànsit, transport públic, previsió meteorològica i més.<br/>Accedeix al catàleg de <a  target="_blank" href="http://governobert.gencat.cat/ca/dades_obertes/">dades obertes de la Generalitat de Catalunya.</a>',
            },
            columnThree: {
                title: 'Geoserveis',
                content: 'Urbanisme, medi ambient, equipaments locals, cadastre i altres portals. <br/>Connecta amb els més de 500 geoserveis catalogats per la <a  target="_blank" href="http://www.ide.cat/">Infraestructura de Dades de Catalunya (IDEC)</a>',
            },
        },
        highlightTwo: {
            title: 'Crea',
            subtitle: 'els teus propis mapes de manera ràpida i fàcil',
            columnOne: {
                title: 'Dibuixa',
                content: 'Dibuixa punts, línies i polígons.<br/> Escull les teves icones i estils personalitzats.',
            },
            columnTwo: {
                title: 'Carrega dades',
                content: 'Carrega les teves pròpies dades (drag and drop).<br/>Múltiples formats: KML, GPX, DXF, SHP, GEOJSON, etc.',
            },
            columnThree: {
                title: 'Combina fonts d\'informació',
                content: 'Visualitza continguts de Twitter i Viquipèdia.<br/>Enllaça servidors WMS i TMS, i afegeix serveis JSON.',
            },
        },
        highlightThree: {
            title: 'Visualitza',
            subtitle: 'tots els teus mapes',
            columnOne: {
                title: 'Multidispositiu',
                content: 'Adaptable a qualsevol dispositiu: PC, telèfon mòbil, tauleta.',
            },
            columnTwo: {
                title: 'Imprimeix',
                content: 'Crea impressions de qualitat i personalitzables.<br/>Fes captures de pantalla per a informes i presentacions.',
            },
            columnThree: {
                title: 'Descarrega',
                content: 'Accedeix al centre de descàrrega.<br/>Exporta les teves dades en diversos formats.',
            },
        },
        highlightFour: {
            title: 'Comparteix',
            subtitle: 'els teus mapes instantàniament',
            columnOne: {
                title: 'A les xarxes socials',
                content: 'Comparteix els teus mapes a Google+, Twitter i Facebook.',
            },
            columnTwo: {
                title: 'Envia per correu',
                content: 'Comparteix l\'enllaç al teu mapa per email.',
            },
            columnThree: {
                title: 'Insereix i enllaça',
                content: 'Inclou el teu mapa en el teu lloc web.',
            },
        },
        buttons: {
            seeMoreMaps: 'Veure més mapes',
            createMap: 'Fes el teu mapa',
            goToGallery: 'Galeria de mapes',
            mapsEditor: 'Editor de mapes',
        },
    },
    es: {
        highlightOne: {
            title: 'Explora',
            subtitle: 'la geoinformación de Catalunya y el mundo',
            columnOne: {
                title: 'Mapas e imágenes aéreas',
                content: 'Bases topográficas, ortofotomapas vigentes, límites administrativos, mapas históricos y otros.<br/>Accede a toda la información del <a target="_blank" title="Institut Cartogràfic i Geològic de Catalunya" href="http://www.icgc.cat">Institut Cartogràfic i Geològic de Catalunya (ICGC)</a>',
            },
            columnTwo: {
                title: 'Datos en tiempo real',
                content: 'Estado e incidéncias de tráfico, transporte público, previsión meteorológica y más.<br/>Accede al catálogo de <a target="_blank" title="Dades Obertes Gencat" href="http://governobert.gencat.cat/ca/dades_obertes/">datos abiertos de la Generalitat de Catalunya.</a>',
            },
            columnThree: {
                title: 'Geoservicios',
                content: 'Urbanismo, medio ambiente, equipamientos locales, catastro y otros portales.<br/>Conecta con más de 500 geoservicios catalogados por la <a target="_blank" title="Infraestructura de Dades de Catalunya " href="http://www.geoportal-idec.cat"> Infraestructura de Dades de Catalunya (IDEC)</a>',
            },
        },
        highlightTwo: {
            title: 'Crea',
            subtitle: 'tus propios mapas de manera rápida y fácil',
            columnOne: {
                title: 'Dibuja',
                content: 'Dibuja puntos, líneas y polígonos.<br/>Escoge tus iconos y estilos personalizados.',
            },
            columnTwo: {
                title: 'Carga datos',
                content: 'Carga tus propios datos (drag and drop).<br/>Múltiples formatos: KML, GPX, DXF, SHP, GEOJSON, etc.',
            },
            columnThree: {
                title: 'Combina fuentes de información',
                content: 'Visualiza contenidos de Twitter y Wikipedia.<br/>Enlaza servidores WMS y TMS, y añade servicios JSON.',
            },
        },
        highlightThree: {
            title: 'Visualiza',
            subtitle: 'todos tus mapas',
            columnOne: {
                title: 'Multidispositivo',
                content: 'Adaptable a cualquier dispositivo: PC, teléfono móvil, tableta.',
            },
            columnTwo: {
                title: 'Imprime',
                content: 'Crea impresiones de calidad y personalizables.<br/>Toma capturas de pantalla para informes y presentaciones.',
            },
            columnThree: {
                title: 'Descarga',
                content: 'Accede al centro de descarga.<br/>Exporta tus datos en distintos formatos.',
            },
        },
        highlightFour: {
            title: 'Comparte',
            subtitle: 'tus mapas instantáneamente',
            columnOne: {
                title: 'En las redes sociales',
                content: 'Comparte tus mapas en Google+, Twitter y Facebook.',
            },
            columnTwo: {
                title: 'Envia por correo',
                content: 'Comparte el enlace a tu mapa por email.',
            },
            columnThree: {
                title: 'Inserta y enlaza',
                content: 'Incluye tu mapa en tu sitio web.',
            },
        },
        buttons: {
            seeMoreMaps: 'Ver más mapas',
            createMap: 'Crea tu mapa',
            goToGallery: 'Galería de mapas',
            mapsEditor: 'Editor de mapas',
        },
    },
    en: {
        highlightOne: {
            title: 'Browse',
            subtitle: 'the geoinformation of Catalonia and the world',
            columnOne: {
                title: 'Aerial maps and images',
                content: 'Topographic databases, current orthophotomaps, administrative boundaries, old maps and more.<br/>Access all the information of the <a href="http://www.icgc.cat" target="_blank">Institut Cartogràfic i Geològic de Catalunya (ICGC)</a>',
            },
            columnTwo: {
                title: 'Real time data',
                content: 'Conditions and traffic incidents, public transport, weather forecast and more.<br/>Access the data catalog of the <a target="_blank" href="http://governobert.gencat.cat/ca/dades_obertes/">open data of Generalitat de Catalunya.</a>',
            },
            columnThree: {
                title: 'Geoservices',
                content: 'Planning, environment, local facilities, land registry and other portals.<br/>Connect with more than 500 geoservices cataloged by <a target="_blank" href="http://www.ide.cat/">Infraestructura de Dades de Catalunya (IDEC)</a>',
            },
        },
        highlightTwo: {
            title: 'Create',
            subtitle: 'your own maps quickly and easily',
            columnOne: {
                title: 'Draw',
                content: 'Draw points, lines and polygons.<br/>Choose your icons and custom styles.',
            },
            columnTwo: {
                title: 'Load data',
                content: 'Upload your own data (drag and drop).<br/>Many different formats: KML, GPX, DXF, SHP, GEOJSON, etc.',
            },
            columnThree: {
                title: 'Combine sources of information',
                content: 'View content from Twitter and Wikipedia.<br/>Link to WMS and TMS servers, and add JSON services.',
            },
        },
        highlightThree: {
            title: 'Visualize',
            subtitle: 'all your maps',
            columnOne: {
                title: 'Mutli-device',
                content: 'Suitable to any device: PC, phone, tablet.',
            },
            columnTwo: {
                title: 'Print',
                content: 'Create customizable quality prints.<br/>Take screenshots for reports and presentations.',
            },
            columnThree: {
                title: 'Download',
                content: 'Access the download center.<br/>Export your data in many formats.',
            },
        },
        highlightFour: {
            title: 'Share',
            subtitle: 'your maps instantly',
            columnOne: {
                title: 'In social networks',
                content: 'Share your maps on Google+, Twitter and Facebook.',
            },
            columnTwo: {
                title: 'Send by email',
                content: 'Share the link to your map over email.',
            },
            columnThree: {
                title: 'Insert and link',
                content: 'Embed your map in your website.',
            },
        },
        buttons: {
            seeMoreMaps: 'See more maps',
            createMap: 'Create your own map',
            goToGallery: 'Map gallery',
            mapsEditor: 'Map editor',
        },
    },
};



// WEBPACK FOOTER //
// ./src/home/home-translations.js